import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Alessandro Rossignoli
 * id 044D1C2C-2EA5-4058-A3B0-0550BD2E3170
 * name alert-minus-outline
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alert-minus-outline.svg
 * tags
 * - Alert / Error 
 */
export const AlertMinusOutlineIcon = createSvgIcon(<><path d="M11 15.5H13V17.5H11V15.5M14 19C14 18.86 14 18.73 14 18.6H5.4L12 7.3L16.11 14.44C16.62 14 17.2 13.65 17.84 13.41L12 3.3L2 20.6H14.22C14.08 20.09 14 19.56 14 19M13 10.5H11V14.5H13V10.5M16 18V20H24V18H16Z" /></>, 'AlertMinusOutlineIcon');
export default AlertMinusOutlineIcon